var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tw-flex tw-justify-center tw-items-center tw-min-h-screen tw-bg-gray-200 tw-p-4 ie_tw-h-screen",attrs:{"data-cy":"setup-company"}},[_c(_vm.component,{tag:"Component",attrs:{"date":_vm.date},on:{"date-selected":_vm.setDate,"next":_vm.next}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }